import React from "react";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import { Link } from "react-router-dom";
import { FiSearch, FiMail } from "react-icons/fi";

function IconButton({ children, onClick, title }) {
    return (
        <button className="flex items-center gap-2 px-4 py-2 rounded-md text-sm text-bkack hover:bg-white/5 transition-colors" onClick={onClick} title={title}>
            {children}
            <span className="hidden md:inline">{title}</span>
        </button>
    );
}

function Header() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    return (
        <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-gradient-to-b from-yellow-700 to-yellow-600/50 border-b border-yello/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
                        <img src="/semperor.png" alt="Semperor" className="w-10 h-10 object-contain" />
                        <span className="text-black font-semibold text-lg text-black">Semperor Games</span>
                    </div>

                    <nav className="hidden md:flex items-center gap-6 text-sm text-yellow-900">
                        <Link to="/" className="hover:text-black">Home</Link>
                        <Link to="/about" className="hover:text-black">About</Link>
                        <Link to="/contact" className="hover:text-black">Contact</Link>
                        <Link to="/privacy" className="hover:text-black">Privacy</Link>
                    </nav>

                    <div className="flex items-center gap-3">
                        <div className="hidden sm:flex items-center bg-white/6 rounded-md px-2 py-1">
                            <FiSearch className="text-black" />
                            <input placeholder="Search games" className="bg-transparent outline-none ml-2 text-sm placeholder-black text-black w-40" />
                        </div>
                        <div className="hidden md:flex">
                            <IconButton onClick={() => navigate('/contact')} title="Contact us"><FiMail /></IconButton>
                        </div>
                        <button className="md:hidden p-2" onClick={() => setOpen(v => !v)}>
                            <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d={open ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} /></svg>
                        </button>
                    </div>
                </div>

                {/* mobile nav */}
                {open && (
                    <div className="md:hidden py-3 flex flex-col gap-2">
                        <Link to="/" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Home</Link>
                        <Link to="/about" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">About</Link>
                        <Link to="/contact" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Contact</Link>
                        <Link to="/privacy" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Privacy</Link>
                    </div>
                )}
            </div>
        </header>
    );
}
export default Header;